import React, { useState, useEffect } from "react";
import ParentPanel from "../panel/ParentPanel";
import api from "../../../api/api";
import "../styles/homework.css";

const HomeworkPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [homeworkList, setHomeworkList] = useState([]);
  const [activeHomework, setActiveHomework] = useState(null);

  useEffect(() => {
    fetchHomework();
  }, []);

  const fetchHomework = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("❌ No token found");
        setHomeworkList([]);
        return;
      }

      const res = await api.get("/api/homework/student", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setHomeworkList(res.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch homework:", err);
      setHomeworkList([]);
    }
  };

  const handleCardClick = (hw) => setActiveHomework(hw);
  const closeDetailView = () => setActiveHomework(null);

  return (
    <>
      <ParentPanel onToggle={setIsSidebarCollapsed} />

      <div
        className={`hw-main-container ${
          isSidebarCollapsed ? "collapsed" : ""
        }`}
      >
        <h2 className="hw-page-title">Homework</h2>

        {/* Homework cards */}
        <div className="hw-card-grid">
          {homeworkList.length > 0 ? (
            homeworkList.map((hw) => (
              <div
                key={hw.id}
                className="hw-card-item"
                style={{
                  backgroundColor: hw.color || "#00bfff",
                  color: "#fff",
                }}
                onClick={() => handleCardClick(hw)}
              >
                <h4 className="hw-card-subject">{hw.subject}</h4>
                <p className="hw-card-topic">{hw.topic}</p>
                <small className="hw-card-date">
                  Due: {new Date(hw.due_date).toLocaleDateString("en-IN")}
                </small>
              </div>
            ))
          ) : (
            <p className="hw-empty-msg">No homework assigned yet.</p>
          )}
        </div>

        {/* Detail Modal */}
        {activeHomework && (
          <div className="hw-detail-overlay">
            <div className="hw-detail-box">
              <button className="hw-close-btn" onClick={closeDetailView}>
                ✖
              </button>

              <div
                className="hw-detail-header"
                style={{
                  backgroundColor: activeHomework.color || "#00bfff",
                  color: "#fff",
                }}
              >
                <h2>{activeHomework.subject}</h2>
                <p>{activeHomework.topic}</p>
              </div>

              <table className="hw-detail-table">
                <tbody>
                  <tr>
                    <td><b>Teacher</b></td>
                    <td>{activeHomework.teacher_name}</td>
                  </tr>
                  <tr>
                    <td><b>Due Date</b></td>
                    <td>
                      {new Date(activeHomework.due_date).toLocaleDateString(
                        "en-IN"
                      )}
                    </td>
                  </tr>
                  {activeHomework.comment && (
                    <tr>
                      <td><b>Comment</b></td>
                      <td>{activeHomework.comment}</td>
                    </tr>
                  )}
                  <tr>
                    <td><b>Questions</b></td>
                    <td>
                      <ol>
                        {activeHomework.questions?.map((q, idx) => (
                          <li key={idx}>{q}</li>
                        ))}
                      </ol>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HomeworkPage;
